<template>
  <div class="new-section">
    <div class="m-container">

      <!-- login section -->
      <div class="row">
        <!-- login form -->
        <div class="col-xs-12 col-sm-12 col-md-6 the-form">
          <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
          <div class="form-body">
            <!-- form -->
            <q-form @submit.prevent="login" class="login-form" v-if="!forgetPassword">
              <!-- email -->
              <label>Email</label>
              <q-input reactive-rules label-color="secondary" filled v-model="formData.email"
                       label="Enter Email" lazy-rules :rules="formRules.email"/>

              <!-- password -->
              <label>Password</label>
              <q-input type="password" label-color="secondary" filled v-model="formData.password" label="Enter Password"
                       lazy-rules :rules="formRules.password"/>

              <!-- keep me logged in -->
              <!--              <div class="q-gutter-sm">
                              <q-checkbox size="xs" v-model="keep_login" label="Keep Me Login"/>
                            </div>

                            &lt;!&ndash; terms and conditions &ndash;&gt;
                            <div class="q-gutter-sm">
                              <q-checkbox size="xs" v-model="agree_terms"
                                          label="I Agree To The Terms And Conditions"/>
                            </div>-->

              <!-- submit button -->
              <a href="" class="main-color" @click.prevent="forgetPassword = true">Forget Password ?</a>
              <div class="submit">
                <ButtonComponent>Login</ButtonComponent>
              </div>
            </q-form>

            <q-form @submit.prevent="forgetPasswordHandler" class="login-form" v-else>
              <!-- email -->
              <label>Email</label>
              <q-input reactive-rules label-color="secondary" filled v-model="forgetEmail"
                       label="Enter Email" lazy-rules :rules="formRules.email"/>

              <p class="text-red" v-for="(err, index) in forgetErrors" :key="index">{{err}}</p>

              <!-- submit button -->
              <div class="submit">
                <ButtonComponent>Reset Password</ButtonComponent>
              </div>
            </q-form>

          </div>
        </div>

        <!-- login image -->
        <div class="col-sm-12 col-md-6 login-img">
          <img src="@/assets/img/login/loginimg.svg">
        </div>
      </div>

      <!-- model alert -->
      <q-dialog v-model="alert">
        <q-card>
          <q-card-section>
            <div class="text-h6">Alert</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            <p v-for="formError in formErrors" :key="formError.id">{{ formError }}</p>
            <p>{{ formDone }}</p>
          </q-card-section>

          <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" v-close-popup/>
          </q-card-actions>
        </q-card>
      </q-dialog>

    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent.vue"
import ContactUs from "../home/ContactUs";
import LinksFooter from "@/components/layouts/LinksFooter";

export default {
  data: () => ({
    formData: {
      email: '',
      password: '',
    },
    formRules: {
      email: [val => val !== null && val !== '' || 'Please enter your email'],
      password: [val => val !== null && val !== '' || 'Please enter your password'],
    },
    formErrors: [],
    alert: false,
    loading: false,
    formDone: '',
    keep_login: false,
    agree_terms: false,
    forgetPassword: false,
    forgetEmail: null,
    forgetErrors: null
  }),
  components: {LinksFooter, ContactUs, ButtonComponent},
  methods: {
    /**
     * login method
     * method invoked when we click on login button
     */
    login() {
      this.formErrors = [];
      this.loading = true;
      this.$API.auth.login(this.formData).then(res => {
        this.loading = false;
        this.$router.replace('/profile');
        window.location.reload();
      }).catch(err => {
        this.loading = false;
        this.formErrors.push(err.response.data.message);
        this.alert = true;
        this.$toastr.e(err.response.data.message)
        if (err.response.data.data == 0) {
          this.$emit('reactive', this.formData)
        }
      });
    },

    forgetPasswordHandler() {
      this.$API.auth.forgetPassword(this.forgetEmail)
          .then(() => {
            this.$toastr.s('Please check your email!');
            this.forgetPassword = false
          }).catch(err => {
            this.forgetErrors = err;
      })
    }
  }
}
</script>

<style scoped>
.login-img img {
  width: 100% !important;
}

.page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>